<div class="container-fluid">
    <div class="row">
        <!-- <div class="col-sm-2 col-md-4 "></div> -->
        <div class="col-sm-12 px-5 pt-5">
            <div class="header-container">
                <img src="images/sage-black-logo.svg" alt="Sage" width="120px" height="67.505px">
                <span class="customer-portal-text">{{'signIn.customerPortal' | translate}}</span> <!-- <span></span> -->
            </div>
            @if (isLoading) {
            <mat-spinner diameter="20" class="text-center mx-auto"></mat-spinner>
            }
        </div>
        <div class="col-sm-12 p-5 pt-0 mx-auto">
            <hr>
            <p class="log-into-your-account">{{'signIn.logIntoYourAccount' | translate}}</p>
            <form [formGroup]="signInForm" (ngSubmit)="signIn()">
                <div>
                    <mat-label class="form-label">{{'signIn.emailAddress' | translate }}</mat-label>
                    <mat-form-field class="w-100 " appearance="outline">
                        <input type="email" matInput placeholder="" formControlName="email" maxlength="241" required>
                        @if (signInFormControl['email'].dirty && emailControl?.errors?.['required']) {
                        <mat-error class="font-sm">{{'signIn.emailAddressRequired' | translate}}</mat-error>
                        }
                        @if (signInFormControl['email'].dirty && emailControl?.errors?.['email']) {
                        <mat-error class="font-sm">{{'signIn.emailAddressValid' |translate}} </mat-error>
                        }
                              <!-- @if (emailControl?.hasError('serverError')) {
                        <mat-error class="font-sm">{{emailControl?.getError('serverError')}}</mat-error>
                        } -->
                    </mat-form-field>
                    
                  

                    <mat-label class="form-label">{{'signIn.password' | translate}}</mat-label>
                    <mat-form-field class="w-100" appearance="outline">
                        <input matInput [type]="showPassword() ? 'text' : 'password'" formControlName="password" maxlength="40" required>
                        @if (
                            signInFormControl['password'].dirty && passwordControl?.errors?.['required']
                        ) {
                            <mat-error class="font-sm">{{'signUp.pleaseProvideAPassword' | translate}}</mat-error>
                        }
                        <mat-icon matSuffix class="small cursor-pointer bold" style="cursor: pointer;"
                            [ngStyle]="{color: showPassword() ? 'gray' : '#198754'}"
                            (click)="showPassword.set(!showPassword())">{{showPassword() ? `${'signIn.hide' | translate}`: `${'signIn.show' | translate}`}}</mat-icon>
                        <!-- @if (signInFormControl['password'].dirty && passwordControl?.hasError('serverError')) {
                            <mat-error class="font-sm">{{passwordControl?.getError('serverError')}}</mat-error>
                        } -->
                    </mat-form-field>
                    <!-- <button mat-flat-button class="w-100 outline">Basic</button> -->
                    <!-- <button type="button" class="btn btn-success w-100 font-sm"><small>Log in</small></button> -->
                    <button type="submit" [disabled]="!signInForm.valid || isLoading"
                        class="btn btn-success w-100 my-2"><small>{{'signIn.login' | translate}}</small></button>
                    <button type="button" [disabled]="isLoading" class="btn btn-outline-success w-100 my-2"
                        (click)="navigateToSignUp()"><b><small>{{'signIn.signUpToThePortal' | translate}}</small></b></button>
                    <a href="" class="small link-success ned-to-reset" [routerLink]="['/reset-password']"
                        (click)="navigateToResetPassword()"><b><small>{{'signIn.needToResetYourPasswordOrGetHelpLogginIn?' |
                            translate}}</small></b></a>
                </div>
            </form>
        </div>
        <!-- <div class="col-sm-2 col-md-4"></div> -->
    </div>
</div>